// AdminOne ONLY — Africa Health Nodes Page.
import React, { useCallback, useEffect, useState } from "react";
import { SHELL, africaApi } from "@/api/connectorPackClient";
import AfricaHealthNodeMap from "@/components/africa/AfricaHealthNodeMap";

export default function AdminOneAfricaHealthNodesPage() {
  const [nodes, setNodes] = useState([]);
  const [audit, setAudit] = useState([]);
  const [err,   setErr]   = useState("");
  const load = useCallback(async () => {
    setErr("");
    try {
      const [n, a] = await Promise.all([africaApi.nodes(), africaApi.audit()]);
      setNodes(n.countries || []);
      setAudit(a.events || []);
    } catch (e) { setErr(String(e.message || e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div style={SHELL.page} data-testid="adminone-africa-health-page">
      <h2 style={SHELL.h2}>AdminOne · Hardening v1 · Africa Digital Health</h2>
      <h1 style={SHELL.h1}>Africa Health Nodes</h1>
      <p style={SHELL.dim}>
        No automatic cross-border PHI transfer. Country residency + consent state required for every ingestion.
      </p>
      {err && <div style={SHELL.err} data-testid="africa-err">{err}</div>}
      <AfricaHealthNodeMap nodes={nodes} />
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Audit · {audit.length} event(s)</h2>
        <table style={SHELL.table}>
          <thead><tr><th style={SHELL.th}>Event</th><th style={SHELL.th}>Jurisdiction</th><th style={SHELL.th}>When</th></tr></thead>
          <tbody>
            {audit.map((e) => (
              <tr key={e._id}><td style={SHELL.td}>{e.event_type}</td><td style={SHELL.td}>{e.jurisdiction || "—"}</td><td style={SHELL.td}>{(e.created_at || "").slice(0, 19)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
